export default "__VITE_ASSET__Rqcj06hJ__"